import { replaceKeys } from "./common";

const keys = {
    is_company_owner: "companyOwner",
    is_admin: "admin",
    // account_type: "accountType",
};

const schema = {
    fullname: null,
    admin: false,
    companyOwner: false,
    enabled: true,
    username: "",
    password: "",
    branch: null,
    company: null,
    accountType: "PAYAGENT",
};

export const createUser = (data) => {
  const d = data ? { ...schema, ...data } : { ...schema };
  return replaceKeys(d, keys);
};
